import { Component, OnInit } from '@angular/core';

import { OrderService } from '../services/order.service';
import { Fee } from '../orders/fee';
import { AlertService } from '../alert';
import { AuthenticationService, Token } from '../services';

@Component({
  selector: 'app-fees',
  providers: [OrderService],  
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.css']
})
export class FeesComponent implements OnInit {

  loading = false;
  fees: any[];
  model: Fee = new Fee();

  constructor(
    private orderService: OrderService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.getAllFees();
  }

  removeFee(event) {
    this.loading = true;
    this.orderService.removeFee(event.id)
      .subscribe(
      data => {
        this.getAllFees();
        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  getAllFees() {
    this.loading = true;
    this.orderService.getAllFees()
      .subscribe(
      data => {
        this.fees = data;
        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  addFee() {
    this.model.type='Zusatzaufwand';
    if (this.model.description == null || this.model.description == '') {
      this.alertService.error('Beschreibung fehlt');
      return;
    }
    if (this.model.feeDate == null) {
      this.alertService.error('Datum fehlt');
      return;
    }
    if (this.model.fee == null && this.model.numberOfItems == null) {
      this.alertService.error('Gebühr oder Anzahl fehlt');
      return;
    }
    this.orderService.addFee(this.model)
      .subscribe(
      data => {
        this.loading = false;
        this.getAllFees();        
        this.alertService.success('Gebühr wurde erfolgreich hinzugefügt');
        this.model = new Fee();
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  addPaletteEntry(count: number) {
    this.loading = true;
    let fee = new Fee();
    fee.description = "Paletten Eingang";
    fee.type = "Einlagerung";
    fee.numberOfItems = count;
    fee.feeDate = new Date();
    this.orderService.addFee(fee)
      .subscribe(
      data => {
        this.loading = false;
        this.getAllFees();        
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/fees/fees.component.ts